import { FeatureFlag } from '../FeatureFlag';

/**
 * Renders Watchlist widgets through the new owned grid (`TableModelViewer`, ADR 0014) instead of
 * the ag-grid `ColumnTemplateTableViewer`.
 *
 * The flag is deliberately independent from the Results rollout so either widget can be disabled
 * without affecting the other.
 */
export const enableNewWatchlistGrid = new FeatureFlag({
    key: 'enable-new-watchlist-grid',
    defaultValue: false,
});
